// Static labels for the language-picker drawer itself, keyed by the language currently
// highlighted (not yet saved) there — so the drawer can preview the picked language
// instantly, without switching the rest of the app's i18n until "Save" is pressed.
export const LANGUAGE_DRAWER_LABELS: Record<string, { title: string; save: string }> = {
  uz: { title: 'Til', save: 'Saqlash' },
  ru: { title: 'Язык', save: 'Сохранить' },
  en: { title: 'Language', save: 'Save' },
};

/** Название языка на нём самом — и в списке шторки, и в строке «Язык». */
export const LANGUAGE_NAMES: Record<string, string> = {
  uz: 'O‘zbekcha',
  ru: 'Русский',
  en: 'English',
};
